import React from 'react'
import * as styles from './index.module.css'

const RawHTML = ({ subtitle }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{
            __html: subtitle.childMarkdownRemark.html,
          }}
        ></div>
      </div>
    </div>
  )
}

export default RawHTML
